module.exports = __webpack_public_path__ + "media/P05.d08363b0.mp4";